
import { defineComponent } from "vue";
import { OrderStyle } from "@/services/Models";
import { consts } from "../services/Models";

export default defineComponent({
  name: "EditDownloadSelectOutputOrderStyle",
  props: {
    orderStyle: { type: Number },
  },
  setup(props, context) {
    const orderStyles = new Map([
      [OrderStyle.type1, consts.type1URL],
      [OrderStyle.type2, consts.type2URL],
    ]);

    const updateValue = (e: InputEvent) => {
      const elm = e.target as HTMLInputElement;
      const order = Number.parseInt(elm.value) as OrderStyle;
      if (elm.checked) {
        context.emit("update:orderStyle", order);
      }
    };

    return {
      orderStyles,
      updateValue,
    };
  },
});
